import Link from 'next/link'
import { Button } from '@skop-app/lib-front'
import { useTranslations } from 'next-intl'

import { StatusBanner } from '@/components/molecules'

export const OnboardingHeader = ({ shop }) => {
  const t = useTranslations('tutorial')

  if (!shop?.id) {
    return (
      <StatusBanner className="mb-4">
        {t('shop-activation.description')}
      </StatusBanner>
    )
  }
  if (shop?.id && !shop.shareInfo) {
    return (
      <StatusBanner
        className="mb-4"
        title={t('shop-add-details-reminder.title')}
        action={
          <Button asChild>
            <Link href="/shop/settings/seo">
              {t('shop-add-details-reminder.button')}
            </Link>
          </Button>
        }
      >
        {t('shop-add-details-reminder.description')}
      </StatusBanner>
    )
  }
  if (shop?.id && !shop.enableCart) {
    return (
      <StatusBanner
        className="mb-4"
        title={t('shop-payment.title')}
        action={
          <Button asChild>
            <Link href="/shop/settings/payment">
              {t('shop-payment.button')}
            </Link>
          </Button>
        }
      >
        {t('shop-payment.description')}
      </StatusBanner>
    )
  }
}
